import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './ZH.css';
import img1 from '../Components/Images/TIJ/zx1.png';
import img2 from '../Components/Images/applications/zx1.png';
import img3 from '../Components/Images/applications/zx2.png';
import img4 from '../Components/Images/applications/zx3.png';
import img5 from '../Components/Images/applications/zx4.png';
import img6 from '../Components/Images/applications/zx5.png';
import img7 from '../Components/Images/applications/zx6.png';

function ZX1() {
  const images = [
    { id: 1, src: img2, alt: 'ZX Plus-1 printing expiration dates on bottles in Dubai' },
    { id: 2, src: img3, alt: 'Industrial inkjet printer coding product labels in Dubai' },
    { id: 3, src: img4, alt: 'High-speed carton marking with ZX Plus-1 series printer' },
    { id: 4, src: img5, alt: 'Polybag coding machine for Dubai packaging industry' },
    { id: 5, src: img6, alt: 'Cosmetics batch coding with thermal inkjet technology' },
    { id: 6, src: img7, alt: 'Paper box marking system for Emiratis manufacturers' },
  ];

  return (
    <div>
      <Helmet>
        <title>ZX Plus-1 Series Industrial Inkjet Printer | Dubai Coding Solutions</title>
        <meta name="description" content="High-performance ZX Plus-1 series industrial inkjet printers in Dubai for product coding, expiration dates, and barcode marking on various packaging materials." />
        <meta name="keywords" content="industrial inkjet printer Dubai, ZX Plus-1 printer, product coding machine, expiration date printer, barcode marking system, packaging coding solutions, Dubai manufacturing equipment" />
        <meta property="og:title" content="ZX Plus-1 Series Industrial Inkjet Printer - Dubai" />
        <meta property="og:description" content="Professional coding solutions for Dubai manufacturers with ZX Plus-1 series printers" />
        <link rel="canonical" href="https://www.yourwebsite.com/zx-plus1-printer" />
      </Helmet>

      <section className="handheld-printers">
        <Container>
          <Row className="">
            <Col className="text-center">
              <h1 className="section-title1 fonthead">
                ZX Plus-1 Series <span style={{color:"#3ec63e"}}>Industrial Inkjet Printers</span>
              </h1>
              <p className="section-subtitle1">
                High-speed online coding solutions for Emiratis manufacturing and packaging industries
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center align-items-center">
            <Col xs={12} md={10} lg={6} className="text-center">
              <img 
                src={img1}
                className="img-fluid"
                style={{
                  maxHeight: "70vh",
                  width: "auto",
                  objectFit: "contain"
                }}
                alt="ZX Plus-1 series industrial inkjet printer - Dubai's premier coding solution"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="product-specs">
        <Container>
          <h2 className="section-title1 fonthead mt-5 mb-2">Product Specifications</h2>
          
          <Card className="specs-card shadow-sm">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <div className="feature-list">
                    <h3 className="specs-subtitle">Key Features</h3>
                    <ul className="list-unstyled">
                      <li className="feature-item">
                        <span className="feature-number">1.</span>
                        <span className="feature-text">Durable metallic construction with 7-inch capacitive touch screen</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">2.</span>
                        <span className="feature-text">Easy installation and intuitive interface for Emiratis operators</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">3.</span>
                        <span className="feature-text">24/7 continuous operation for high-volume production lines</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">4.</span>
                        <span className="feature-text">Multi-level user administration for secure access control</span>
                      </li>
                    </ul>
                  </div>
                </Col>
        
                <Col md={8}>
                  <div className="technical-details">
                    <h3 className="specs-subtitle">Applications in Dubai Industries</h3>
                    
                    <Container className="py-2">
                      <Row className="g-4">
                        {images.map((image) => (
                          <Col key={image.id} xs={12} sm={6} md={4}>
                            <div className="image-card">
                              <img 
                                src={image.src} 
                                alt={image.alt}
                                className="img-fluid rounded"
                                style={{maxHeight:"150px"}}
                                loading="lazy"
                              />
                              <div className="image-overlay">
                                <p className="image-caption">{image.alt}</p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section className="">
        <Container>
          <h2 className="section-title1 text-center fonthead mt-5 mb-3">Technical Specifications</h2>
          
          <Card className="specs-card shadow-lg">
            <Card.Body>
              <div className="table-responsive">
                <table className="table table-borderless specs-table">
                  <tbody>
                    <TableRow 
                      parameter="Printing Technology" 
                      value="HP TIJ2.5 Thermal Inkjet Technology for precise marking" 
                    />
                    <TableRow 
                      parameter="Print Resolution" 
                      value="50-1,200 DPI (adjustable for different applications)" 
                      
                    />
                    <TableRow 
                      parameter="Optimal Print Distance" 
                      value="2-5mm for consistent print quality" 
                    />
                    <TableRow 
                      parameter="Print Height Options" 
                      value="1-25.4mm (supports 1-2 print heads)" 
                    />
                    <TableRow 
                      parameter="Maximum Print Speed" 
                      value="Up to 120m/min (high-speed mode for production lines)" 
                      isHighlighted={false}
                    />
                    <TableRow 
                      parameter="Supported Content Types" 
                      value="Dates, Times, Text, Batch Numbers, Images, Barcodes, QR Codes, Database fields" 
                    />
                    <TableRow 
                      parameter="Ink Compatibility" 
                      value="Aqueous, Solvent-based, and UV inks for different materials" 
                    />
                    <TableRow 
                      parameter="Available Ink Colors" 
                      value="Black, White, Red, Yellow, Blue, Green, Invisible (security marking)" 
                    />
                    <TableRow 
                      parameter="Language Support" 
                      value="Arabic, Chinese, English, French, German + 10 more (customizable for Dubai market)"
                      isHighlighted={false}
                    />
                    <TableRow 
                      parameter="Communication Protocol" 
                      value="RS232 for industrial integration" 
                    />
                    <TableRow 
                      parameter="Connection Interfaces" 
                      value="USB, DB9 serial port, I/O, Encoder, Photocell sensor for production line sync" 
                    />
                    <TableRow 
                      parameter="Operating Conditions" 
                      value="Temperature 0~45°C (Recommended: 20~30°C), Humidity 40~60%RH (ideal for Dubai climate)" 
                    />
                    <TableRow 
                      parameter="Power Requirements" 
                      value="Input: 100~240V AC; Output: 12V/4A DC (suitable for Dubai power standards)" 
                    />
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </section>
    </div>
  )
}

const TableRow = ({ parameter, value, icon, isHighlighted = false }) => {
  return (
    <tr className={isHighlighted ? "highlighted-row" : ""}>
      <td className="parameter-cell">
        {icon && <span className="parameter-icon">{icon}</span>}
        <strong>{parameter}</strong>
      </td>
      <td className="value-cell">{value}</td>
    </tr>
  );
};

export default ZX1;